/** Mirrors the company API's compact USD units and one-decimal precision. */
export function formatCompactUsd(
  value: number | null | undefined
): string | null {
  if (value == null || !Number.isFinite(value) || value < 0) return null;
  for (const [threshold, suffix] of [
    [1e9, 'B'],
    [1e6, 'M'],
    [1e3, 'K'],
  ] as const) {
    if (value < threshold) continue;
    const scaled = value / threshold;
    let text = scaled.toFixed(1);
    // Python's formatter rounds exact halfway values to even. Other binary
    // fractions use toFixed's same nearest representable decimal rule.
    if (Number.isInteger(scaled * 4) && (scaled * 10) % 1 === 0.5) {
      const floor = Math.floor(scaled * 10);
      text = ((floor + (floor % 2)) / 10).toFixed(1);
    }
    return `$${text.replace(/\.0$/, '')}${suffix}`;
  }
  return `$${value}`;
}

export function formatUsdBounds(
  lower?: number | null,
  upper?: number | null
): string {
  const lo = lower != null && lower > 0 ? formatCompactUsd(lower) : null;
  const hi =
    upper != null && upper > 0 && upper < 1e12 ? formatCompactUsd(upper) : null;
  if (lo && hi) return `${lo}-${hi}`;
  if (lo) return `${lo}+`;
  return hi ? `Up to ${hi}` : '';
}
